var SpriteSymbol = require("../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "ok",
  "use": "ok-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ok\">\n    <path d=\"M12.8125 2.5L6.25 9.0625L3.1875 6L1 8.1875L6.25 13.4375L15 4.6875L12.8125 2.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol